module.exports = __webpack_public_path__ + "static/media/decline.94fa4974.svg";